import {Entity, IEntity} from "../../shared/domain/entity";
import {IUserHomeConfiguration, UserHomeConfiguration} from "../home-models/home-model";

export interface IUser extends IEntity {
    name: string;
    email: string;
    givenName: string;
    familyName: string;
    roles: string[];
    emailVerified: boolean;
    configurations: IUserHomeConfiguration[];
}

export class User extends Entity implements IUser {
    name: string;
    email: string;
    givenName: string;
    familyName: string;
    roles: string[];
    emailVerified: boolean;
    configurations: UserHomeConfiguration[] = [];

    constructor(data: IUser) {
        super(data);
        this.name = data.name;
        this.email = data.email;
        this.givenName = data.givenName;
        this.familyName = data.familyName;
        this.roles = data.roles;
        this.emailVerified = data.emailVerified;
    }

    getFullName() {
        return `${this.givenName} ${this.familyName}`;
    }

    addConfigurations(configurations: UserHomeConfiguration[]) {
        this.configurations = configurations;
    }
}
